//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			phone: ''
		}
	},
	onLoad(event) {
		this.phone = event.phone
	}
}
